function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.95 8.712c0 .372.129.62.386.867a1.277 1.277 0 001.8 0L9.95 3.02l6.814 6.559a1.277 1.277 0 001.8 0c.515-.495.515-1.238 0-1.733L10.85.421a1.277 1.277 0 00-1.8 0L1.336 7.846c-.257.248-.386.495-.386.866z",
  fill: "#F58220",
  fillRule: "nonzero"
});

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrowUp;